<div class="row modalheigh">
    <div class="col-lg-12 col-md-8 col-sm-6">
        <div class="">
            <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
                     <h4 class="font-weight-normal text-center pt-4">Add New Representative</h4>
            <div class="body">
                <mat-stepper  [linear]="false" #stepper [orientation]="orientation">
                    <mat-step [stepControl]="step1Form">
                      <form #step1Form="ngForm">
                        <ng-template matStepLabel>Representative Info</ng-template>
                          <ng-template class="custom-icon"  matStepperIcon="edit">
                            <mat-icon class="custom-icon">done</mat-icon>
                        </ng-template>
                        <mat-form-field class="small-form-field">
                            <mat-select name="gender" #gender="ngModel" [(ngModel)]="data.user.role" placeholder="Department and Permissions*" required>
                                <mat-option *ngFor="let item of groupsList"
                                value="{{ item.id }}">{{ item.name | titlecase }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="small-form-field">
                            <mat-select name="deptoToCount" #deptoToCount="ngModel" [(ngModel)]="data.user.deptoToCount" placeholder="Select department to keep track of KPIs" required>
                                <mat-option *ngFor="let depto of deptos"
                                value="{{ depto.value }}">{{ depto.viewValue | titlecase }}</mat-option>
                            </mat-select>
                        </mat-form-field >
                        <mat-form-field class="small-form-field">
                            <input class="text-dark" type="text" name="company" matInput #company="ngModel" [(ngModel)]="data.user.company" readonly >
                            <mat-label>Company Name</mat-label>
                        </mat-form-field>
                        <div class="form-row">

                       <div class="col-lg-8">
                        <mat-form-field class="small-form-field">
                            <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel" [(ngModel)]="data.user.ocupation" required>
                            <mat-label>Title</mat-label>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4">
                        <mat-form-field class="small-form-field">
                            <input class="text-dark" type="text" matInput name="iqInitials" #iqInitials="ngModel" [(ngModel)]="data.user.iqInitials">
                            <mat-label>IQ Initials</mat-label>
                        </mat-form-field>
                    </div>
                    </div>
                        <div>
                            <!--  -->
                           <div class="form-row">
                            <div class="col-lg-4 col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="text" matInput name="name" #name="ngModel" [(ngModel)]="data.user.name" required>
                                    <mat-label>First Name</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="text" matInput name="surname" #surname="ngModel" [(ngModel)]="data.user.surname" required>
                                    <mat-label>Last Name</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <mat-form-field class="small-form-field">
                                    <mat-select name="gender" #gender="ngModel" [(ngModel)]="data.user.gender" placeholder="Gender*" required>
                                        <mat-option *ngFor="let sexo of sexos"
                                        [value]="sexo.value">{{ sexo.viewValue }}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                        </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="text" matInput name="email" #email="ngModel" [(ngModel)]="data.user.email" required>
                                    <mat-label>Email</mat-label>
                                </mat-form-field>
<!--                                 <div class="form-group">
                                    <label class="bmd-label-floating">Email</label>
                                    <input type="email" class="form-control form-control-sm" name="email" #email="ngModel" [(ngModel)]="data.user.email">
                                </div> -->
                            </div>
                            
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <mat-label>Hire Date:</mat-label>
                                    <input matInput [matDatepicker]="hirePicker" name="joinusdate" #joinusdate="ngModel" [(ngModel)]="data.user.joinToWork" required>
                                    <mat-datepicker-toggle matIconSuffix [for]="hirePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #hirePicker></mat-datepicker>
                                  </mat-form-field>
    <!--                                 <div class="form-group">
                                            <label style="    margin-bottom: 15px;" class="bmd-label-floating">Hire Date:</label>
                                            <input matInput type="date" class="form-control form-control-sm" name="joinusdate" #joinusdate="ngModel" [(ngModel)]="data.user.joinToWork" required>
                                        </div> -->
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <mat-label>Birth Date:</mat-label>
                                    <input matInput [matDatepicker]="birthPicker" name="birthDate" #birthDate="ngModel" [(ngModel)]="data.user.birthDate" required>
                                    <mat-datepicker-toggle matIconSuffix [for]="birthPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #birthPicker></mat-datepicker>
                                  </mat-form-field>
<!--                                 <div class="form-group">
                                        <label style="margin-bottom: 15px;" class="bmd-label-floating">Birth Date:</label>
                                        <input  matInput type="date" class="form-control form-control-sm" name="birthDate" #birthDate="ngModel" [(ngModel)]="data.user.birthDate" required>
                                    </div> -->
                            </div>

                        </div>
                        <div class="pr-4 mr-4">
                            <mat-checkbox (change)="onCheckboxChange($event)" >Enable as a Driver</mat-checkbox>
                            <mat-checkbox *ngIf="data.user.role !='Administrator'" (change)="BugAdmin($event)" >Bug Admin</mat-checkbox>
                        </div> 
                            <!-- <div class="form-group">
                                <label class="bmd-label-floating">Enable as a Driver</label>
                                 <select name="enable_as_driver" id="enable_as_driver" #enable_as_driver="ngModel" [(ngModel)]="data.user.enableAsDriver" class="form-control">
                                     <option value=null>Please select an option</option>      
                                    <option value='1'>Yes</option>
                                    <option value='0'>No</option>
                            </select>

                            </div> -->
                        
                    
                            <!--  -->
                          <button class="gts-btn-primary-outline" matRipple matStepperNext  [disabled]="!step1Form.valid">Next</button>
                        </div>
                      </form>
                    </mat-step>
                    <mat-step [stepControl]="step2Form" label="Address Info">
                      <form #step2Form="ngForm">
                        <div class="form-row">
                        <div class="col-md-12">
                            <mat-form-field class="small-form-field">
                                <input class="text-dark" type="text" matInput name="address" #address="ngModel" [(ngModel)]="data.user.address" required>
                                <mat-label>Address 1</mat-label>
                            </mat-form-field>
<!--                             <div class="form-group">
                                <label class="bmd-label-floating">Address Line #</label>
                                <input type="text" class="form-control" name="address" #address="ngModel" [(ngModel)]="data.user.address">
                            </div> -->
                        </div>
                        <div class="col-lg-12">
                            <mat-form-field class="small-form-field">
                                <input class="text-dark" type="text" matInput name="address2" #address2="ngModel" [(ngModel)]="data.user.address2">
                                <mat-label>Address 2</mat-label>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field class="small-form-field">
                                <input class="text-dark" type="text" matInput  name="city" #city="ngModel" [(ngModel)]="data.user.city" required>
                                <mat-label>City</mat-label>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field class="small-form-field">
                                <input class="text-dark" type="text" matInput name="colonia" #colonia="ngModel" [(ngModel)]="data.user.colonia" required>
                                <mat-label>State</mat-label>
                            </mat-form-field>
                        </div>
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="text" matInput name="country" #country="ngModel" [(ngModel)]="data.user.country" required>
                                    <mat-label>Country</mat-label>
                                </mat-form-field>
                            </div>


                           
                        </div>
                        <div class="form-row">
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="number" matInput  name="zipCode" #zipCode="ngModel" [(ngModel)]="data.user.zipCode" required>
                                    <mat-label>Zip Code</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="number" matInput   name="mobilePhone" #mobilePhone="ngModel" [(ngModel)]="data.user.mobilePhone" required>
                                    <mat-label>Mobile Phone</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="small-form-field">
                                    <input class="text-dark" type="number" matInput  name="phone" #phone="ngModel" [(ngModel)]="data.user.phone">
                                    <mat-label>Work Phone</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                  <mat-form-field>
                                    <mat-select name="location" #location="ngModel" [(ngModel)]="data.user.location.id" placeholder="Default Warehouse Location" required>
                                      <mat-option *ngFor="let loc of warehouseList" [value]="loc.id">
                                        {{ loc.name }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="row btn-wrapper">
                            <div class="col-lg-1 col-md-1 col-sm-6 col-12 mb-2 mb-sm-0">
                                <button class="gts-btn-primary-outline" matRipple matStepperPrevious>Previous</button>
                            </div>
                            <div class="col-lg-1 col-md-1 col-sm-6 col-12">
                              <button class="gts-btn-primary-outline" matRipple matStepperNext [disabled]="step2Form.invalid">Next</button>
                            </div>
                        </div>
                      </form>
                    </mat-step>
                    <mat-step [stepControl]="step3Form">
                        <form #step3Form="ngForm">
                      <ng-template matStepLabel>Create Password</ng-template>
                      <div class="row">
                        <div class="col-12">
                            <mat-form-field class="small-form-field">
                                <input class="text-dark" type="text" matInput  name="password" #password="ngModel" [(ngModel)]="data.user.password" required>
                                <mat-label>New Password</mat-label>
                            </mat-form-field>
<!--                             <div class="form-group">
                                <label class="bmd-label-floating">Create a Password</label>
                                <input type="text" name="password" #password="ngModel" [(ngModel)]="data.user.password" class="form-control">
                            </div> -->
                        </div>
                    </div>
                      <div class="row btn-wrapper">
                        <div class="col-lg-1 col-md-1 col-sm-6 col-12 mb-2 mb-sm-0">
                             <button class="gts-btn-primary-outline" matRipple matStepperPrevious>Previous</button>
                        </div>
                        <div class="col-lg-1 col-md-1 col-sm-6 col-12">
                            <button class="gts-btn-primary" matRipple (click)="onSubmit()" [disabled]="step3Form.invalid||step1Form.invalid||step2Form.invalid">
                                <span *ngIf="!searching">Save</span>
                                <i *ngIf="searching" class="fa fa-refresh fa-spin fa-1x fa-fw"></i>
                            </button>
                        </div>
                      </div>
                    </form>
                    </mat-step>
                  </mat-stepper>
    <!-- 
                <div mat-dialog-content>

                    <form #userNewForm="ngForm" (ngSubmit)="onSubmit()">
                          <div class="row">
                         <div class="col-md-6">
                                <div class="form-group">
                                    <mat-form-field>
                                        <mat-select name="gender" #gender="ngModel" [(ngModel)]="data.user.role" placeholder="Department and Permissions" required>
                                            <mat-option *ngFor="let item of groupsList"
                                            value="{{ item.id }}">{{ item.name | titlecase }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <mat-form-field>
                                        <mat-select name="deptoToCount" #deptoToCount="ngModel" [(ngModel)]="data.user.deptoToCount" placeholder="Select department to keep track of KPIs" required>
                                            <mat-option *ngFor="let depto of deptos"
                                            value="{{ depto.value }}">{{ depto.viewValue | titlecase }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Company Name</label>
                                    <input type="text" class="form-control" name="company" #company="ngModel" [(ngModel)]="data.user.company" readonly>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Title</label>
                                    <input type="text" class="form-control" name="ocupation" #ocupation="ngModel" [(ngModel)]="data.user.ocupation">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="bmd-label-floating">First Name</label>
                                    <input type="text" class="form-control" name="name" #name="ngModel" [(ngModel)]="data.user.name" required>
                                    <span *ngIf="!name.valid && name.touched">
                      ¡Name not valid!
                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Last Name</label>
                                    <input type="text" class="form-control" name="surname" #surname="ngModel" [(ngModel)]="data.user.surname" required>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Email</label>
                                    <input type="email" class="form-control" name="email" #email="ngModel" [(ngModel)]="data.user.email">
                                </div>
                            </div>

                            <div class="col-md-4">

                                     <div class="form-group">
                                        <label class="bmd-label-floating">Enable as a Driver</label>
                                         <select name="enable_as_driver" id="enable_as_driver" #enable_as_driver="ngModel" [(ngModel)]="data.user.enableAsDriver" class="form-control">
                                             <option value=null>Please select an option</option>      
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                    </select>

                                    </div>


                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-4">

                                <div class="form-group">
                                    <label class="bmd-label-floating">Gender</label>
                                     <select name="Please select" #gender="ngModel" [(ngModel)]="data.user.gender" class="form-control">
                                        <option value="" disabled>Please select an option</option>
                                        <option *ngFor="let sexo of sexos" [value]="sexo.value">{{ sexo.viewValue }}</option>
                                </select>

                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                        <label style="    margin-bottom: 15px;" class="bmd-label-floating">Hire Date:</label>
                                        <input type="date" class="form-control" name="joinusdate" #joinusdate="ngModel" [(ngModel)]="data.user.joinToWork" required>
                                    </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                        <label style="margin-bottom: 15px;" class="bmd-label-floating">Birth Date:</label>
                                        <input type="date" class="form-control" name="birthDate" #birthDate="ngModel" [(ngModel)]="data.user.birthDate" required>
                                    </div>
                            </div>


                        </div>
                        <div class="row">

                            <h4 class="card-title" style="margin-left: 20px; margin-top: 40px;">Address information</h4>

                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Address Line #</label>
                                    <input type="text" class="form-control" name="address" #address="ngModel" [(ngModel)]="data.user.address">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Address Line 2 #</label>
                                    <input type="text" class="form-control" name="address2" #address2="ngModel" [(ngModel)]="data.user.address2">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">City</label>
                                    <input type="text" class="form-control" name="city" #city="ngModel" [(ngModel)]="data.user.city">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">State</label>
                                    <input type="text" class="form-control" name="colonia" #colonia="ngModel" [(ngModel)]="data.user.colonia">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Country</label>
                                    <input type="text" class="form-control" name="country" #country="ngModel" [(ngModel)]="data.user.country">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Zip Code</label>
                                    <input type="text" class="form-control" name="zipCode" #zipCode="ngModel" [(ngModel)]="data.user.zipCode">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Work Phone</label>
                                    <input type="text" class="form-control" name="phone" #phone="ngModel" [(ngModel)]="data.user.phone">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Mobile Phone</label>
                                    <input type="text" class="form-control" name="mobilePhone" #mobilePhone="ngModel" [(ngModel)]="data.user.mobilePhone">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <h4 class="card-title" style="margin-left: 20px; margin-top: 40px;">Settings </h4>
                        </div>

                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group">
                                  <mat-form-field>
                                    <mat-select name="location" #location="ngModel" [(ngModel)]="data.user.location.id" placeholder="Default Warehouse Location">
                                      <mat-option *ngFor="let loc of warehouseList" [value]="loc.id">
                                        {{ loc.name }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                            </div>


                        </div>

                    </form>

                </div> -->
                </div>
            <!--  -->
        </div>

    </div>

    <!--     <div class="col-md-4">




        <div class="card">
            <div class="card-header card-header-icon card-header-rose">
                <div class="card-icon">
                    <i class="material-icons"></i>
                </div>
                <h4 class="card-title">Password</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="bmd-label-floating">Create a Password</label>
                            <input type="text" name="password" #password="ngModel" [(ngModel)]="data.user.password" class="form-control">
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div> -->




<div>
<!--         <div mat-dialog-actions>

            <button mat-button class="btn btn-success" [mat-dialog-close]="data.user" cdkFocusInitial [disabled]="!userNewForm.valid" >Save</button>
        </div> -->